/**
 * Trigger a browser download for a (possibly cross-origin) file URL.
 *
 * The BE signs these URLs with `Content-Disposition: attachment`, which is what
 * actually forces the save dialog — the `download` attribute alone is ignored on
 * cross-origin URLs. The attribute is still set so same-origin/local-disk dev
 * URLs behave the same way.
 */
export const triggerFileDownload = (url, filename) => {
  if (!url) return;
  const a = document.createElement("a");
  a.href = url;
  if (filename) a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export default triggerFileDownload;
